// Backend role mirror. For tenant users the JWT `role` claim is the domain
// Role enum serialised by name (Role.ToString() → "Employee" | "TeamLead" |
// "TenantAdmin"); see JwtSessionTokenIssuer in the web-api. The platform
// SuperAdmin uses the "superadmin" value (AuthorizationPolicies).
export const ROLES = {
  SuperAdmin: 'superadmin',
  TenantAdmin: 'TenantAdmin',
  TeamLead: 'TeamLead',
  RegularEmployee: 'Employee',
} as const;

export type UserRole = (typeof ROLES)[keyof typeof ROLES];
